import page from '../api/page.api'
import store from './index.js'
// root state object.
// each Vuex instance is just a single state tree.
const state = {
  pages: [],
  detailedPage: null
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  refreshPages (state, pages) {
    state.pages = pages
  },
  addDetailedPage (state, page) {
    state.detailedPage = page
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  refreshPageList (context) {
    page.api.getAllPages()
      .then(response => {
        context.commit('refreshPages', response.data.results)
      },
      error => {
        console.log('impossible to load page list from api: ' + error.text())
      })
  },
  getDetailedPage (context, id) {
    // si l'article cherché n'est pas en cache
    page.api.getDetailedPage(id)
      .then(response => {
        context.commit('addDetailedPage', response.data)
      },
      error => {
        console.log('impossible to detailed page : ' + error.text())
      })
  },
  invalidateDetailedPage (context) {
    context.commit('addDetailedArticle', null)
  }
}

// getters are functions
const getters = {
  allPages: state => {
    return state.pages
  },
  allFilteredPages: state => {
    if (store.getters.activatedClub && state.pages) {
      let al = store.getters.activatedClub
      let filtered = state.pages.filter(page => { return page.featured_club !== undefined && page.featured_club.id === al.id })
      return filtered
    }
    return state.pages
  },
  detailedPage: state => {
    return state.detailedPage
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/page.js